/**
 * Created by Andrey Popov on 22.04.20
 */

const Prolongation = function (options) {
    cleverapps.EventEmitter.call(this);

    options = options || {};

    this.counter = 0;
    this.fixedPrice = options && options.fixedPrice;

    this.onCompleteOffer = function () {};
};

Prolongation.prototype = Object.create(cleverapps.EventEmitter.prototype);
Prolongation.prototype.constructor = Prolongation;

Prolongation.prototype.getOfferCurrencyPrice = function () {
    return RewardsConfig.Prolongation.hardPrice[this.counter];
};

Prolongation.prototype.checkEligibleFree = function (reward) {
    return (!cleverapps.user.checkAvailable(cleverapps.config.availables.PROLONGATION) && !cleverapps.forces.isShown(Forces.FREE_PROLONGATION_FORCE))
        || (reward === Prolongation.REWARDS.SLOT && !cleverapps.forces.isShown(Forces.FREE_EXTRA_SLOT_FORCE));
};

Prolongation.prototype.getOffer = function (reward, noFree) {
    let moves;
    if (reward === Prolongation.REWARDS.MOVES) {
        moves = Game.currentGame.getProlongationMoves();
    }
    if (!noFree && this.checkEligibleFree(reward)) {
        return {
            reward,
            type: Product.TYPE_FREE,
            price: 0,
            moves,
            text: Messages.get("FREE"),
            force: (
                reward === Prolongation.REWARDS.SLOT
                    ? Forces.FREE_EXTRA_SLOT_FORCE
                    : Forces.FREE_PROLONGATION_FORCE
            )
        };
    }

    if (this.isAdAvailable()) {
        return {
            reward,
            type: Product.TYPE_ADS,
            moves,
            text: "##"
        };
    }

    if (!this.hasOffer()) {
        return undefined;
    }

    const price = this.getOfferCurrencyPrice();

    if (reward === Prolongation.REWARDS.MOVES && this.isCustomWhaleFirstStep()) {
        moves *= 2;
    }
    return {
        reward,
        type: Product.TYPE_HARD,
        price,
        moves,
        text: `$$${price}`
    };
};

Prolongation.prototype.acceptOffer = function (offer) {
    let spend;

    switch (offer.type) {
        case Product.TYPE_FREE:
            this.onAcceptOffer(offer);

            break;

        case Product.TYPE_ADS:
            cleverapps.rewardedAdsManager.playRewarded(AdsLimits.TYPES.PROLONGATION, () => {
                this.onAcceptOffer(offer);
            }, () => {
                this.trigger("adsCanceled", offer);
            });

            break;

        case Product.TYPE_HARD:
            spend = levels.user.spendHard.bind(levels.user);

            if (spend(cleverapps.EVENTS.SPENT.CONTINUE, offer.price)) {
                this.onAcceptOffer(offer);
                this.escalateToUpperLevel();

                const statsParams = Game.currentGame ? Game.currentGame.getLevelStatsParams() : {};
                statsParams.value = offer.price;

                cleverapps.metrics.logEvent(cleverapps.EVENTS.HINT_USED, statsParams);

                cleverapps.metrics.logEvent(`${cleverapps.EVENTS.MOVES_BOUGHT}_${offer.price}`);
            }
            break;
    }
};

Prolongation.prototype.isAdAvailable = function () {
    return cleverapps.adsLimits.state(AdsLimits.TYPES.PROLONGATION) === AdsLimits.STATE_READY
        && connector.ads.isRewardedAvailable;
};

Prolongation.prototype.isCustomWhaleFirstStep = function () {
    return false;
};

Prolongation.prototype.escalateToUpperLevel = function () {
    if (this.fixedPrice) {
        return;
    }

    this.counter++;

    if (this.counter >= RewardsConfig.Prolongation.hardPrice.length && Game.currentGame.getMode() !== GameBase.MODE_HIGHSCORE) {
        this.counter = RewardsConfig.Prolongation.hardPrice.length - 1;
    }
};

Prolongation.prototype.getAlertMessage = function (prolongationType) {
    if (prolongationType === Prolongation.REWARDS.OCTOPUS_HUNT) {
        const octopusMission = cleverapps.missionManager.findRunningMission(Mission.TYPE_OCTOPUS_HUNT);
        const octopusHunt = octopusMission.logic.octopusHunt;

        return Messages.get("OctopusHuntProlongationWindow.leftStages", {
            stages: octopusHunt.calcStagesBeforeBonus()
        });
    }

    const game = Game.currentGame;
    const mission = game.secondaryMission;

    const lantern = typeof Lantern !== "undefined" && Lantern.Get();
    const percent = game.getPercentOfCompletion();
    const goldCollected = game.rewards[GameBase.REWARD_HARD];

    let type = undefined;
    if (game.rewards[GameBase.REWARD_BOOSTERS]) {
        type = Prolongation.GIVE_UP_TYPES.BOOSTER;
    } else if (lantern && lantern.isActive(game.level) && lantern.getCurrentStreak() > 0) {
        type = Prolongation.GIVE_UP_TYPES.LANTERN;
    } else if (mission && mission.isRunning() && game.getMissionRewardAmount(mission.type) > 0) {
        type = Prolongation.GIVE_UP_TYPES.MISSION;
    } else if (goldCollected && goldCollected > 0) {
        type = Prolongation.GIVE_UP_TYPES.GOLD_COLLECTED;
    } else if (percent >= 0.70) {
        type = Prolongation.GIVE_UP_TYPES.NEARLY;
    }

    if (type === undefined) {
        return;
    }

    const message = [Messages.get("GiveUpAlert.text1")];

    if (type === Prolongation.GIVE_UP_TYPES.NEARLY) {
        message.push(Messages.get("AddMovesWindow.nearlyDoneGiveUp"));
    }

    if (cleverapps.ListBreaks().length > 0) {
        message.push(Messages.get("GiveUpAlert.text2"));
    }

    return message.join("\n");
};

Prolongation.prototype.getText = function (reward) {
    if (reward === Prolongation.REWARDS.BOMB) {
        return Messages.get("PostponeBombWindow.addMoves", {
            moves: BombOnCard.MOVES_TO_ADD
        });
    }

    if (reward === Prolongation.REWARDS.FLAGS) {
        return Messages.get("RemoveFlagsWindow.text");
    }

    if (reward === Prolongation.REWARDS.OCTOPUS_HUNT) {
        return Messages.get("OctopusHuntProlongationWindow.Text");
    }

    return Messages.get("ProlongationWindow.addMoves");
};

Prolongation.prototype.hasOffer = function () {
    if (cleverapps.flags.monetization === cleverapps.Flags.MONETIZATION_DISABLED) {
        return false;
    }

    return RewardsConfig.Prolongation.hardPrice[this.counter] !== undefined;
};

Prolongation.prototype.onAcceptOffer = function (offer) {
    this.trigger("acceptOffer", offer);
};

Prolongation.GIVE_UP_TYPES = {
    BOOSTER: 0,
    LANTERN: 1,
    MISSION: 2,
    GOLD_COLLECTED: 3,
    NEARLY: 4
};

Prolongation.REWARDS = {};
Prolongation.REWARDS.MOVES = 1;
Prolongation.REWARDS.BOMB = 2;
Prolongation.REWARDS.FLAGS = 3;
Prolongation.REWARDS.SLOT = 4;
Prolongation.REWARDS.OCTOPUS_HUNT = 5;
